import Customer from 'models/customer';
import CustomerApi from 'api/customer';
import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import path from 'path';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import routeUtils from 'util/routeUtils';
import SelectMaster from './SelectMaster';
import toolFlow from 'helpers/toolFlow';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';
import {router, events} from 'lib';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.customer.merge-system] rendering page');
  ReactDOM.render(
    <IntlWrapper>
      <WrappedMergeSystemsContainer customerID={params.id} page={params.page || 0} return={!!params.return} />
    </IntlWrapper>, container);
  events.publish('page-change', {page: 'customer'});
};

let returnRender = (container, params) => {
  return render(container, Object.assign({}, params, {return: true}));
};

console.info('[UI.page.customer.merge-systems] register route');
router.rr.add([{path: 'customer/:id/merge-systems-report/:page', handler: routeUtils.requireAuth(returnRender)}]);
router.rr.add([{path: 'customer/:id/merge-systems/:page', handler: routeUtils.requireAuth(render)}]);


const propTypes = {
  View: PropTypes.any.isRequired,
  setPage: PropTypes.func.isRequired,
  customerID: PropTypes.string,
  return: PropTypes.bool.isRequired,
};

class MergeSystemWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: new Customer({}),
      first: null,
      second: null,
    };
  }

  componentWillMount() {
    if (!this.props.customerID) {
      return;
    }

    let id = this.props.customerID;

    if (id.includes('.')) {
      id = id.split('.')[0];
    }
    CustomerApi.getCustomer(id)
      .then(cust => {
        this.setState({
          customer: cust,
        });
      });
  }

  cancel = () => {
    this.setState({
      first: null,
      second: null,
    });
    this.props.setPage(0);
  };

  selectSystems = (first, second) => {
    this.setState({
      first,
      second,
    });
    this.props.setPage(1);
  };

  render() {
    let {View} = this.props;
    let pageTitle = 'Customer';
    let {formatMessage} = this.props.intl;

    if (this.state.customer.customerContacts.length > 0) {
      let contact = this.state.customer.customerContacts[0];
      let contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;

      pageTitle = <span>{(contactName || '').trim() || 'Customer'}</span>;
    }

    return <div className='container'>
      <Header mainTitle={pageTitle} mainTitleReturn={path.join(location.hash, '..', '..')} subTitle={formatMessage({id: 'system.widget.merge.systems'})}>
        <i className={'pointer icon bl ' + (this.state.customer.flag ? 'bl-flag-filled' : 'bl-flag')}
          data-event-category='User'
          title={formatMessage({id: 'general.important.notes.flagged'})}
          data-event-action='customer-flag'
          onClick={() => window.location.hash = path.join(window.location.hash, '..', 'notes')}/>
        <i onClick={this.toggleFavourite}
          title={formatMessage({id: 'general.preferred.customer'})}
          data-event-category='User' data-event-action='customer-fav'
          className={'icon bl ' + (this.state.customer.favourite ? 'bl-star-filled' : 'bl-star')}/>
      </Header>
      <View
        cancel={this.cancel}
        customer={this.state.customer}
        first={this.state.first}
        second={this.state.second}
        return={this.props.return}
        selectSystems={this.selectSystems} />
    </div>;
  }
}
MergeSystemWrapper.displayName = 'MergeSystemWrapper';
MergeSystemWrapper.propTypes = propTypes;

const MergeSystemsContainer = toolFlow(MergeSystemWrapper, Instructions, SelectMaster);

let WrappedMergeSystemsContainer = injectIntl(MergeSystemsContainer);
